import script from "./CarlDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CarlDetail.vue?vue&type=script&setup=true&lang=js"

import "./CarlDetail.vue?vue&type=style&index=0&id=734e8d3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-734e8d3e"]])

export default __exports__